import { useRouter } from 'next/router';

import routes from '@/shared/constant/routes';
import { useStore } from '@/shared/hooks/context/createGenericContext';
import { useFreeTrial } from '@/shared/hooks/useFreeTrial';

export function useGoToAydiAi() {
  const router = useRouter();
  const [store, setStore] = useStore((s) => s);
  const { freeTrialOver, hasSubscription } = useFreeTrial();

  const redirectToAydiAi = (query?: string) => {
    // handle expired trail
    if (freeTrialOver && !hasSubscription) {
      router.push({
        pathname: routes.subscription,
      });
      return;
    }
    // turn on real farm
    if (store?.isDemoFarm) {
      setStore({
        asset: store?.assetsList?.farms.find((f) => f.id !== -1),
        isDemoFarm: false,
      });
    }
    // Navigate to aydi intelligence with the query as a parameter
    router.push({
      pathname: routes.aydiIntelligence,
      query: { query },
    });
  };

  return { redirectToAydiAi };
}
